
import { isEmpty } from "../../Util"
import { useSelector } from "react-redux";

const Back = ({renderer, message,callBackUrl=undefined}) => {

    const backUrl = useSelector((state) => state.Reducer.backUrl)
    const url = callBackUrl ?? backUrl

    return (
        !isEmpty(url) && renderer &&
        <div className="mt-5">
            <a href={url} className="az-link" > 
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#636263" className="bi bi-chevron-left me-1" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                    </svg>
                </span>
                <span className="az-back-label">{message}</span> 
            </a>
        </div>
    );
}
export default Back;